// extracted by mini-css-extract-plugin
export default {"gallery":"MatchGuide_gallery__OAmKb","gallery_item":"MatchGuide_gallery_item__xTqVS","guide_img":"MatchGuide_guide_img__lMfEi"};